"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCurrentStep = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const configuration_1 = require("../../screens/entry/configuration");
const entryTheme = (0, configuration_1.findDomainConfig)();
const initialState = {
    currentStep: 0,
    entryTheme: entryTheme,
};
const slice = (0, toolkit_1.createSlice)({
    name: "entry",
    initialState,
    reducers: {
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
    },
});
exports.setCurrentStep = slice.actions.setCurrentStep;
exports.default = slice.reducer;
